import * as DashboardConstants from '../DashboardConstants';

export const trustIndexSummaryTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'executions',
        header: DashboardConstants.TotalExecutions
    },
    {
        key: 'totalCompletions',
        header: DashboardConstants.TotalCompletions
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRate
    }
];

export const successRateTableHeaders = [
    {
        key: 'geo',
        header: DashboardConstants.Geo
    },
    {
        key: 'executions',
        header: DashboardConstants.TotalExecutions
    },
    {
        key: 'completions',
        header: DashboardConstants.Completions
    },
    {
        key: 'stopped',
        header: DashboardConstants.Stopped
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRatePercent
    },
    {
        key: 'comments',
        header: DashboardConstants.Comments
    }
];

export const botSummaryReportTableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.BotId,
        hidden: false,
        optional: false
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform,
        hidden: false,
        optional: false
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea,
        hidden: false,
        optional: false
    },
    {
        key: 'processName',
        header: DashboardConstants.ProcessName,
        hidden: false,
        optional: false
    },
    {
        key: 'geo',
        header: DashboardConstants.Geo,
        hidden: false,
        optional: false
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy,
        hidden: false,
        optional: false
    },
    {
        key: 'supportStatus',
        header: DashboardConstants.SupportStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'processCritical',
        header: DashboardConstants.ProcessCritical,
        hidden: false,
        optional: false
    },
    {
        key: 'lastRunStartTime',
        header: DashboardConstants.LastRunStartTime,
        hidden: false,
        optional: false
    },
    {
        key: 'runStatus',
        header: DashboardConstants.RunStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'countOfOpenIncidents',
        header: DashboardConstants.CountOfOpenIncidents,
        hidden: false,
        optional: false
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRatePercent,
        hidden: false,
        optional: false
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel,
        hidden: true,
        optional: true
    },
    {
        key: 'completions',
        header: DashboardConstants.Completions,
        hidden: false,
        optional: false
    },
    {
        key: 'stopped',
        header: DashboardConstants.Stopped,
        hidden: false,
        optional: false
    },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses,
        hidden: false,
        optional: false
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations,
        hidden: false,
        optional: false
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns,
        hidden: false,
        optional: false
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns,
        hidden: false,
        optional: false
    },
    {
        key: 'comments',
        header: DashboardConstants.Comments,
        hidden: true,
        optional: true
    },
];

export const automataStartedOnTimeTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'scheduleMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'startedOnTime',
        header: DashboardConstants.StartedOnTime
    },
    {
        key: 'startedOnTimePercentage',
        header: DashboardConstants.StartedOnTimePercentage
    }
];

export const automataRunsOnTimeTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    // {
    //     key: 'scheduleMisses',
    //     header: 'Sch. misses'
    // },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'runOnTime',
        header: DashboardConstants.RunsOnTime
    },
    {
        key: 'runOnTimePercentage',
        header: DashboardConstants.RunOnTimePercentage
    }
];